import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { getOfficersList, postNonSponsoredRoleAssignment, postSponsoredRoleAssignment } from '../../../../global/ducks/wam-api';
import { getFormattedDateYmd } from '../../../../global/helpers/date-helpers';
import { parseChanged, parsePhone, formatPhone } from '../../../../global/helpers/form-data-helper';
import { ApiStatuses, YesNoIndicators } from '../../../../global/models/api-model';
import { OfficerTypes } from './institution-officers-models';
import { dispatchSetOfficers, setAddOfficerStatus, setTempPassword } from './institution-officers-slices';
import { OfficerAddFormValues, WithAccessTo } from './officer-add-form-model';
import { cleanData } from './helpers/institution-officers-helper';

function successCallback(dispatch: Dispatch<any>, institutionClientNumber: string) {
	dispatch(getOfficersList(institutionClientNumber, (response) => dispatchSetOfficers(response, dispatch)));
}

export function addSponsoredOfficerRequest(dispatch: Dispatch<any>, initialValues: OfficerAddFormValues, values: OfficerAddFormValues, institutionClientNumber: string) {
	dispatch(apiErrorClear());
	dispatch(setAddOfficerStatus(ApiStatuses.None));

	const { nonEpiscopal, officerType, designation_salutation, office_email_address, personal_email_address, ...rest } = values;

	const withPhoneUpdate = parsePhone(rest) as OfficerAddFormValues;
	const toUpdate = parseChanged(initialValues, withPhoneUpdate, true) as OfficerAddFormValues;

	// const { nonEpiscopal, officerType, designation_salutation, ...rest } = toUpdate;

	const designationSalutationSplit = designation_salutation?.split('|').map(x => x.trim());
	const volunteer = values.nonEpiscopal === YesNoIndicators.Yes;
	const person_data = {
		known_as: toUpdate.known_as,
		date_of_birth: getFormattedDateYmd(toUpdate.date_of_birth, true),
		tax_id: toUpdate.tax_id,
		gender: toUpdate.gender,
		mobile_phone_contact_attributes: {
			mobile_phone_area_code: toUpdate.mobile_phone_area_code,
			mobile_phone_country_code: toUpdate.mobile_phone_country_code,
			mobile_phone_extension: toUpdate.mobile_phone_extension,
			mobile_phone_number: formatPhone(toUpdate.mobile_phone_number, toUpdate.mobile_phone_country_code),
		},
		mailing_address_attributes: {
			mailing_address_1: toUpdate.mailing_address_1,
			mailing_address_2: toUpdate.mailing_address_2,
			mailing_address_3: toUpdate.mailing_address_3,
			mailing_country: toUpdate.mailing_country,
			mailing_city: toUpdate.mailing_city,
			mailing_state: toUpdate.mailing_state,
			mailing_postal_code: toUpdate.mailing_postal_code,
		},
		isMatchPerson: false,
	};

	const roles: any = {};

	if (values?.withAccessTo?.includes(WithAccessTo.map)) {
		roles.employee_roster = [{
			role: officerType,
			institution: {
				client_number: institutionClientNumber,
			},
		}];
	}

	if (values?.withAccessTo?.includes(WithAccessTo.cic)) {
		roles.customer_360 = [{
			role: OfficerTypes.CICAdmin,
			institution: {
				client_number: institutionClientNumber,
			},
		}];
	}

	const payload: any = {
		sponsored: volunteer,
		new_user: {
			user_data: {
				designation: designationSalutationSplit[0],
				salutation: designationSalutationSplit[1],
				first_name: toUpdate.first_name,
				last_name: toUpdate.last_name,
				suffix: toUpdate.suffix,
				date_of_birth: getFormattedDateYmd(toUpdate.date_of_birth, true),
				tax_id: toUpdate.tax_id,
				home_phone_country_code: toUpdate.home_phone_country_code,
				home_phone_area_code: toUpdate.home_phone_area_code,
				home_phone_number: formatPhone(toUpdate.home_phone_number, toUpdate.home_phone_country_code),
				home_phone_extension: toUpdate.home_phone_extension,
				business_phone_area_code: toUpdate.business_phone_area_code,
				business_phone_country_code: toUpdate.business_phone_country_code,
				business_phone_extension: toUpdate.business_phone_extension,
				business_phone_number: formatPhone(toUpdate.business_phone_number, toUpdate.business_phone_country_code),
			},
			person_data,
		},
		role_assignments: roles,
	};

	if (office_email_address) {
		payload.new_user.user_data.office_email_address = office_email_address;
	}

	if (personal_email_address) {
		payload.new_user.user_data.personal_email_address = personal_email_address;
	}

	const purifiedPayload = cleanData(payload);

	dispatch(postSponsoredRoleAssignment(purifiedPayload, (data) => {
		dispatch(setAddOfficerStatus(ApiStatuses.Success));
		successCallback(dispatch, institutionClientNumber);
		if (volunteer) {
			dispatch(setTempPassword(data?.data?.temporary_password));
		}
	}));
}

export function addNonSponsoredOfficerRequest(dispatch: Dispatch<any>, officerType: OfficerTypes, personGuid: string, institutionClientNumber: string, addedOfficeEmail: string, addedPersonEmail: string, withAccessTo: string[]) {
	dispatch(apiErrorClear());
	dispatch(setAddOfficerStatus(ApiStatuses.None));

	const roles: any = {};

	if (withAccessTo?.includes(WithAccessTo.map)) {
		roles.employee_roster = [{
			role: officerType,
			institution: {
				client_number: institutionClientNumber,
			},
		}];
	}

	if (withAccessTo?.includes(WithAccessTo.cic)) {
		roles.customer_360 = [{
			role: OfficerTypes.CICAdmin,
			institution: {
				client_number: institutionClientNumber,
			},
		}];	
	}

	const payload: any = {
		role_assignments: roles,
	};

	
	if (addedOfficeEmail) {
		payload.office_email_address = addedOfficeEmail;
	}
	if (addedPersonEmail) {
		payload.personal_email_address = addedPersonEmail;
	}
	dispatch(postNonSponsoredRoleAssignment(personGuid, payload, () => {
		dispatch(setAddOfficerStatus(ApiStatuses.Success));
		successCallback(dispatch, institutionClientNumber);
	}));
}